import styled from "styled-components";
import * as colors from "themes/colors";

export default styled.div`
  padding: 25px 35px 25px ${props => (props.isEndPicker ? "40px" : "20px")};
  border-top: solid 1px ${colors.telenorTextColorAlpha50};
  border-bottom: solid 1px ${colors.telenorTextColorAlpha50};
`;
